import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { StockItemHeaderStockProperty } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class StockItemHeaderStockPropertyService extends TmsWebBaseEditCreateService<
  StockItemHeaderStockProperty,
  StockItemHeaderStockProperty
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('StockItemHeaderStockProperty', $localize`Stock Item StockProperty`);
  }

  getStockPropertiesForStockItem(id: string): Observable<StockItemHeaderStockProperty[]> {
    return this.httpService.get<StockItemHeaderStockProperty[]>(`${this.apiUrl}/StockPropertiesForStockItem?id=${id}`);
  }
}
